<template>
	<div id="page">
		<user-activity-modal v-if="showUserActivityModal" @close="showUserActivityModal = false" :userId="taskModel.receiverUserId"></user-activity-modal>

		<div class="page-content">
			<div class="page-title page-title-small">
				<h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ثبت {{lableText('TaskName')??'وظیفه'}} <button data-menu="HelpMenu" class="position-static"><i class="fa fa-question-circle helpIco"></i></button></h2>
				<!--<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click="reloadPage"><i class="font-16 fa fa-redo"></i></button>-->
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>

			<div class="card card-style">
				<div class="content">
					<div class="input-style input-style-2 has-icon input-required">
						<i class="input-icon fa fa-check-square brand-color"></i>
						<span class="color-highlight">عنوان</span>
						<input class="form-control" type="text" v-model="taskModel.title" @input="v$.taskModel.title.$touch()" :class="{invalid:v$.taskModel.title.$error}" @blur="setDescription">
						<p class="text-danger" v-if="v$.taskModel.title.required.$invalid && v$.taskModel.title.$dirty">لطفا {{lableText('Title')??'عنوان'}} را وارد کنید.</p>
					</div>
					<div class="mb-3" v-show="isFieldEnabled('WorkGroupId')">
						<v-select dir="rtl" label="title" placeholder="کارگروه" :filterable="WorkGroupList.length>10" :searchable="WorkGroupList.length>10" :options="WorkGroupList" :reduce="p => p.workGroupId" v-model="taskModel.workGroupId" @option:selected="ChangeWorkGroup" @option:cleared="ChangeWorkGroup">
							<template slot="option">
								<div class="d-center">
									{{ option.title }}
								</div>
							</template>
						</v-select>
					</div>
					<div class="mb-3">
						<div class="d-flex">
							<div class="w-100">
								<v-select v-model="taskModel.receiverUserId" @option:selected="getDefaultsForTask" :class="{invalid:v$.taskModel.receiverUserId.$error}" dir="rtl" label="title" placeholder="ارجاع گیرنده" :filterable="localUserListList.length>10" :searchable="localUserListList.length>10" :options="localUserListList" :reduce="p => p.userId">
									<template v-slot="option">
										<div class="d-center">
											{{ option.title }}
										</div>
									</template>
								</v-select>
							</div>
							<button :disabled="taskModel.receiverUserId==null" class="btn btn-xxs rounded-sm btn-primary btnNexInput" @click="onShowUserActivityClick"><i class="fa fa-search"></i></button>
						</div>
						<p class="text-danger" v-if="v$.taskModel.receiverUserId.required.$invalid && v$.taskModel.receiverUserId.$dirty">لطفا {{lableText('ReferrerUserId')??'ارجاع گیرنده'}} را انتخاب کنید.</p>
					</div>

					<div class="mb-3">
						<v-select :class="{invalid:v$.taskModel.taskTypeId.$error}" dir="rtl" label="title" :placeholder="lableText('TaskType')??'نوع وظیفه'" :filterable="taskTypeList.length>10" :searchable="taskTypeList.length>10" :options="taskTypeList" :reduce="p => p.taskTypeId" v-model="taskModel.taskTypeId" @option:selected="CalcTaskTimeByTaskTypeId">
							<template #list-footer>
								<button v-if="isMinVersion==true" @click="onShowTypeModal(true)" class="btn btn-xxs rounded-xl btn-success list-add-btn" href="#"><i class="fa fa-plus"></i></button>
							</template>
						</v-select>
						<p class="text-danger" v-if="v$.taskModel.taskTypeId.required.$invalid && v$.taskModel.taskTypeId.$dirty">لطفا {{lableText('TaskType')??'نوع وظیفه'}} را انتخاب کنید.</p>

					</div>
					<div>
						<div class="input-style input-style-2 has-icon input-required">
							<i class="input-icon fa fa-calendar-check brand-color"></i>
							<span class="color-highlight" :class="{'input-style-1-active' : taskModel.startDateTime!==null}">{{lableText('StartDateTime')??'تاریخ و ساعت شروع'}}</span>
							<input type="text" class="form-control ltr d-inline-block" v-model="taskModel.startDateTime" id="startDT" @input="SetTimingChanged(true)" :class="{invalid:v$.taskModel.startDateTime.$error}" />
						</div>
						<p class="text-danger" v-if="v$.taskModel.startDateTime.required.$invalid && v$.taskModel.startDateTime.$dirty">لطفا {{lableText('StartDateTime')??'تاریخ و ساعت شروع'}} را وارد کنید.</p>
					</div>


					<div class="mb-4">
						<div class="d-flex justify-content-between align-items-center">
							<div class="d-flex align-items-center">
								<i class="fa fa-clock pl-2 brand-color"></i>
								<label class="mb-0 font-12 font-weight-bold">زمان معین شده</label>
							</div>
							<div class="d-flex flex-column">
								<div class="d-flex justify-content-between align-items-center">
									<label class="mb-0 font-12 font-weight-bold w-50 text-center">دقیقه</label>
									<span class="font-13 font-weight-bold px-3"></span>
									<label class="mb-0 font-12 font-weight-bold w-50 text-center">ساعت</label>
								</div>
								<div class="ltr">
									<input placeholder="00" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskModel.suggestPersonTimeHour" @change="saveHeader" @input="v$.taskModel.suggestPersonTimeHour.$touch()" :class="{invalid:v$.taskModel.suggestPersonTimeHour.$error}">
									<span class="font-13 font-weight-bold px-2">:</span>
									<input placeholder="00" @input="() => { if(taskModel.suggestPersonTimeMinute > 59 || taskModel.suggestPersonTimeMinute < 0) { taskModel.suggestPersonTimeMinute = ''}}" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskModel.suggestPersonTimeMinute" @change="saveHeader" :class="{invalid:v$.taskModel.suggestPersonTimeMinute.$error}">
									<!--<input placeholder="00" maxlength="2" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskModel.suggestPersonTimeMinute" @change="saveHeader" @input="v$.taskModel.suggestPersonTimeMinute.$touch()" :class="{invalid:v$.taskModel.suggestPersonTimeMinute.$error}">-->
								</div>
							</div>
						</div>
						<p class="text-danger mt-2" v-if="v$.taskModel.suggestPersonTimeHour.between.$invalid && v$.taskModel.suggestPersonTimeHour.$dirty">ساعت باید مقداری از ۰ تا ۱۰۰۰ داشته باشد.</p>
						<p class="text-danger mt-2" v-if="v$.taskModel.suggestPersonTimeMinute.between.$invalid && v$.taskModel.suggestPersonTimeMinute.$dirty">دقیقه باید مقداری از ۰ تا ۵۹ داشته باشد.</p>
						<p class="text-danger " v-if="v$.taskModel.suggestedPersonTime.required.$invalid && v$.taskModel.suggestedPersonTime.$dirty">لطفا زمان معین شده را وارد کنید.</p>

					</div>

					<div class="mb-3">
						<div class="input-style input-style-2 has-icon input-required mb-1">
							<i class="input-icon fa fa-calendar-times brand-color"></i>
							<span class="color-highlight" :class="{'input-style-1-active' : taskModel.endDateTime!==null}">{{lableText('EndDateTime')??'تاریخ و ساعت پایان'}}</span>
							<input type="text" class="form-control ltr d-inline-block" v-model="taskModel.endDateTime" id="endDT" @input="SetTimingChanged(true)" :class="{invalid:v$.taskModel.endDateTime.$error}" />
						</div>
						<p class="text-danger" v-if="v$.taskModel.endDateTime.required.$invalid && v$.taskModel.endDateTime.$dirty">لطفا {{lableText('EndDateTime')??'تاریخ و ساعت پایان'}} را وارد کنید.</p>

					</div>
					<div class="collapse pt-1" id="collapse-8">
						<preferenceTypeList txtPlaceholder="ضرورت" class="mb-3" @selectPreferenceType="selectPreferenceType"></preferenceTypeList>



						<div class="mb-3">
							<v-select :class="{invalid:v$.taskModel.priorityId.$error}" dir="rtl" label="title" :placeholder="lableText('PriorityId')??'اولویت'" :filterable="false" :searchable="false" :options="priorityList" :reduce="p => p.priorityId" v-model="taskModel.priorityId">
								<template slot="option">
									<div class="d-center">
										{{ option.title }}
									</div>
								</template>
							</v-select>
							<p class="text-danger" v-if="v$.taskModel.priorityId.required.$invalid && v$.taskModel.priorityId.$dirty">لطفا {{lableText('PriorityId')??'اولویت'}} را وارد کنید.</p>

						</div>



						<div class="mb-3" v-show="isFieldEnabled('TeamUserIdsList')">
							<v-select dir="rtl" label="title" :placeholder="lableText('TeamUserIdsList')??'سایر کاربران (اعضای تیم/ ناظرین)'" multiple chips :filterable="localUserListList.length>10" :searchable="localUserListList.length>10" :options="localUserListListForTeam" :reduce="p => p.userId" v-model="taskModel.teamUserIdsList">
								<template slot="option">
									<div class="d-center">
										{{ option.title }}
									</div>
								</template>
							</v-select>
						</div>

						<div class="mb-3" v-if="!isMinVersion">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="taskModel.personId" label="title" @option:selected="onchangePerson" placeholder="شخص/شرکت" :filter="PersonFilter" :options="PersonList" :reduce="p => p.personId">
										<template v-slot="option">
											<div class="d-center">
												{{ option.title }}
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>

						<div class="mb-3">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="taskModel.projectId" label="fullTitle" @option:selected="onchangeProject" placeholder="پروژه" :filter="ProjectFilter" :options="ProjectList" :reduce="p => p.projectId">
										<template v-slot="option">
											<div class="d-center">
												{{ option.fullTitle }}
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>

						<div class="mb-3" v-if="(!isMinVersion) && HasCom">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="taskModel.preInvoiceId" label="strDocNo" @option:selected="onchangePreInvoice" placeholder=" پیش فاکتور فروش کالا/خدمات" :filter="PreInvoiceFilter" :options="PreInvoiceList" :reduce="p => p.preInvoiceId">
										<template v-slot="option">
											<div class="d-center">
												<span>{{  option.strDocNo }}</span>
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>

						<div class="mb-3" v-if="!isMinVersion">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="taskModel.contractId" label="strDocNo" @option:selected="onchangeContract" placeholder="قرارداد" :filter="ContractFilter" :options="ContractList" :reduce="p => p.contractId">
										<template v-slot="option">
											<div class="d-center">
												<span>{{  option.strDocNo }}</span>
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>

						<div class="mb-3" v-if="!isMinVersion">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="taskModel.meetingId" label="strDocNo" @option:selected="onchangeMeeting" placeholder="جلسه" :filter="MeetingFilter" :options="MeetingList" :reduce="p => p.meetingId">
										<template v-slot="option">
											<div class="d-center">
												<span>{{  option.strDocNo }}</span>
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>

						<div class="mb-3" v-if="!isMinVersion">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="taskModel.letterId" label="strDocNo" @option:selected="onchangeLetter" placeholder="نامه" :filter="LetterFilter" :options="LetterList" :reduce="p => p.letterId">
										<template v-slot="option">
											<div class="d-center">
												<span>{{  option.strDocNo }}</span>
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>

						<div class="mb-3" v-if="(!isMinVersion) && HasCom">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="taskModel.invoiceId" label="strDocNo" @option:selected="onchangeInvoice" placeholder="فاکتور فروش کالا/خدمات" :filter="InvoiceFilter" :options="InvoiceList" :reduce="p => p.invoiceId">
										<template v-slot="option">
											<div class="d-center">
												<span>{{  option.strDocNo }}</span>
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>

						<div class="mb-3" v-if="(!isMinVersion) && HasCom">
							<div class="d-flex">
								<div class="w-100">
									<v-select dir="rtl" v-model="taskModel.buyId" label="strDocNo" @option:selected="onchangeBuy" placeholder="خرید کالا/خدمات" :filter="BuyFilter" :options="BuyList" :reduce="p => p.buyId">
										<template v-slot="option">
											<div class="d-center">
												<span>{{  option.strDocNo }}</span>
											</div>
										</template>
									</v-select>
								</div>
							</div>
						</div>

						<div class="input-style input-style-2 has-icon input-required">
							<i class="input-icon fa fa-check-square brand-color"></i>
							<span class="color-highlight just-top-lable">شناسه</span>
							<input maxlength="150" class="form-control" type="text" v-model="taskModel.reference" placeholder="مثال: عنوان اشخاص ، پروژه ، مشخصه و یا موارد مشابه">
						</div>

						<div v-show="isFieldEnabled('ReminderDateTime')">
							<div class="input-style input-style-2 has-icon input-required">
								<i class="input-icon fa fa-calendar-check brand-color"></i>
								<span class="color-highlight" :class="{'input-style-1-active' : taskModel.reminderDateTime!==null}">{{lableText('ReminderDateTime')??'تاریخ و ساعت یادآوری'}}</span>
								<input type="text" class="form-control ltr d-inline-block" v-model="taskModel.reminderDateTime" id="reminderDT" />
							</div>
						</div>

						<div class="card mx-0 mb-2">
							<!--<div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
								<button data-toggle="collapse" data-target="#collapse-description">
									<i class="fa fa-edit mt-2"></i>
									<span :class="{'input-style-1-active' : taskModel.description!==null}">{{lableText('Description')??'توضیحات'}}</span>
									<i class="fa fa-angle-down"></i>
								</button>
							</div>-->
							<div>
								<textarea v-model="taskModel.description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px" @input="v$.taskModel.description.$touch()" :class="{invalid:v$.taskModel.description.$error}" placeholder="توضیحات"></textarea>
								<p class="text-danger" v-if="v$.taskModel.description.required.$invalid && v$.taskModel.description.$dirty">لطفا {{lableText('Description')??'توضیحات'}} را وارد کنید.</p>

							</div>
						</div>
						<button class="btn btn-link speechToTextBtn mb-3" @pointerdown="startR"
								@pointerup="stopR">
							<span :class="btnRecord">
								<span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
							</span>
							<img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
						</button>
						<taskfolderitem-list :taskId="0" :taskFolderId="0" @setFolderItemList="setFolderItemList" :readOnly="false"></taskfolderitem-list>
						<att-list :docId="0" v-bind:destination="'TaskFolder'" @setAttList="SetAttList($event)" @attInProgress="AttInProgress($event)" :canAdd="true" :canDelete="true" :oldAttList="[]" :hasLocation="true"></att-list>
					</div>
					<button data-toggle="collapse" data-target="#collapse-8" class="btn btn-xxs btn-full rounded-sm bg-highlight font-900 collapse-a w-100" id="moreLessDetails" @click="toggleClasslessDetails()">
						<span class="collapse-a-title"></span>
					</button>
					<button :disabled="Loading || attInProgress" class="btn btn-xxs mt-3 btn-full bg-green1-dark rounded-sm font-900 w-100 btn_checkSmsm" @click.prevent="CheckTaskTitle">
						<i class="fa fa-check font-10 ml-2"></i>
						ثبت
					</button>
				</div>
			</div>


		</div>
		<date-picker type="datetime" v-model="taskModel.startDateTime" :auto-submit="true" format="jYYYY/jMM/jDD HH:mm" element="startDT" :jump-minute="5" />
		<date-picker type="datetime" v-model="taskModel.endDateTime" :auto-submit="true" format="jYYYY/jMM/jDD HH:mm" element="endDT" :jumpMinute="5" />
		<date-picker type="datetime" v-model="taskModel.reminderDateTime" :auto-submit="true" format="jYYYY/jMM/jDD HH:mm" element="reminderDT" :jump-minute="5" />

		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید...</div>
			</div>
		</transition>

		<Help-Menu :title="pageTitle" keyEn="TaskList"></Help-Menu>
		<transition name="modal" enter-active-class="animated fadeIn" appear>
			<div v-if="showTypeModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container">
						<div class="modal-body m-0">
							<slot name="body">
								<task-type-create :inModal="true" @close="showTypeModal=false"></task-type-create>
							</slot>
						</div>
						<div class="modal-footer py-1 px-2">
							<slot name="footer">
								<button class="btn btn-xxs rounded-s bg-red1-light" @click="showTypeModal=false">
									<i class="fa fa-times ml-2"></i>
									بستن
								</button>
							</slot>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
	import useVuelidate from '@vuelidate/core'
	import {
		required, between
	} from "@vuelidate/validators";
	import 'vue-select/dist/vue-select.css';
	import { maska } from 'maska'

	import taskTypeCreate from '../TaskType/CreateTaskTypeInModal.vue';
	import AttList from '../Components/AttList.vue';
	import TaskFolderItemList from './TaskFolderItemList.vue';
	import UserActivity from './ActivityAnalysis.vue';
	import DatePicker from 'vue3-persian-datetime-picker';
	import HelpMenu from '../Components/HelpMenu.vue';
	import VueSimpleAlert from 'vue3-simple-alert';
	import PreferenceType from '../Components/PreferenceTypeList.vue';
	const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition
	export default {
		components: {
			"Help-Menu": HelpMenu,
			DatePicker,
			"att-list": AttList,
			"preferenceTypeList": PreferenceType,
			"task-type-create": taskTypeCreate,
			"user-activity-modal": UserActivity,
			"taskfolderitem-list": TaskFolderItemList
		},
		setup: () => ({ v$: useVuelidate() }),
		data() {
			return {
				pageTitle: "",
				showUserActivityModal: false,
				attInProgress: false,
				modified: false,
				showTypeModal: false,
				timingChanged: false,
				showType: false,
				sr: null,
				btnRecord: "btn btn-danger speechToTextBtn-i",
				taskModel: {
					taskNo: null,
					taskDate: null,
					title: null,
					taskTypeId: null,
					receiverUserId: null,
					priorityId: 2,
					suggestedPersonTime: "",
					startDateTime: this.$store.getters.GetServerDateTime,
					startTime: null,
					endDateTime: null,
					endTime: null,
					refPersonId: null,
					description: null,
					attList: [],
					reference: null,
					reminderDateTime: null,
					teamUserIdsList: [],
					teamUserIds: null,
					currentUserId: 0,
					taskFolderItemList: [],
					suggestPersonTimeHour: null,
					suggestPersonTimeMinute: null,




					leadId: null,
					workGroupId: null,
					projectId: null,
					invoiceId: null,
					preInvoiceId: null,
					contractId: null,
					letterId: null,
					personId: null,
					meetingId: null,
					preBuyInvoiceId: null,
					buyId: null,

					projectTitle: null,
					preInvoiceTitle: null,
					invoiceTitle: null,
					letterTitle: null,
					buyTitle: null,
					contractTitle: null,
					personTitle: null,
					meetingTitle: null,
					preBuyInvoiceTitle: null,
					leadTitle: null,


					preferenceTypeTitle: "",
					preferenceTypeId: null
				},
			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			},
			priorityList() {
				return this.$store.getters.GetPriorityList;
			},
			taskTypeList() {
				return this.$store.getters.GetTaskTypeList;
			},
			localUserListList() {
				return this.$store.getters.GetLocalUserListList;
			},
			localUserListListForTeam() {
				var list = this.$store.getters.GetLocalUserListList;
				return list.filter(x => x.userId != this.taskModel.receiverUserId && x.userId != this.taskModel.currentUserId);
			},
			workGroupList() {
				return this.$store.getters.GetWorkGroupList;
			},
			meetingList() {
				return this.$store.getters.GetMeetingList;
			},
			propsToWatch() {
				return `${this.taskModel.title}|${this.taskModel.description}|${this.taskModel.endDateTime}|${this.taskModel.taskTypeId}|${this.taskModel.receiverUserId}|${this.taskModel.attList}|${this.taskModel.suggestedPersonTime}`;
			},




			PersonList() {
				return this.$store.getters.GetPersonList;
			},
			ProjectList() {
				return this.$store.getters.GetProjectList;
			},
			PreInvoiceList() {
				return this.$store.getters.GetPreInvoiceList;
			},
			ContractList() {
				return this.$store.getters.GetContractList;
			},
			InvoiceList() {
				return this.$store.getters.GetInvoiceList;
			},
			LetterList() {
				return this.$store.getters.GetLetterList;
			},
			MeetingList() {
				return this.$store.getters.GetMeetingList;
			},
			PreBuyInvoiceList() {
				return this.$store.getters.GetPreBuyInvoiceList;
			},
			BuyList() {
				return this.$store.getters.GetBuyList;
			},
			WorkGroupList() {
				return this.$store.getters.GetWorkGroupList;
			},
			HasCom() {
				return this.$store.getters.GetHasCom;
			},

		},
		watch: {

			propsToWatch: {
				handler: function () {
					this.modified = true;
				},
				deep: true
			},
			localUserListList: {
				handler: function () {
					if (this.localUserListList.length === 1) {
						this.taskModel.receiverUserId = this.localUserListList[0].userId;
						this.getDefaultsForTask();
					}
				}
			},
			'taskModel.workGroupId'(value) {
				this.onChangeWorkGroup();
			},
			'taskModel.personId'(value) {
				this.onchangePerson();
			},
			'taskModel.projectId'(value) {
				this.onchangeProject();
			},
			'taskModel.preInvoiceId'(value) {
				this.onchangePreInvoice();
			},
			'taskModel.contractId'(value) {
				this.onchangeContract();
			},
			'taskModel.meetingId'(value) {
				this.onchangeMeeting();
			},
			'taskModel.invoiceId'(value) {
				this.onchangeInvoice();
			},
			'taskModel.letterId'(value) {
				this.onchangeLetter();
			},
			'taskModel.buyId'(value) {
				this.onchangeBuy();
			},
		},
		created() {
			this.pageTitle = "راهنمای ثبت " + (this.lableText('TaskName') ?? 'وظیفه');
			this.$store.dispatch("GetPriorityListFromServer");
			this.$store.dispatch("GetTaskTypeListFromServer");
			this.getUserList();
			this.$store.dispatch("GetServerDateTimeFromServer");
			this.getServerDateTime();
			//this.getMeetingList();
			this.GetCurrenctUserId();
			this.$store.dispatch("CheckUserSMS");



			this.$store.dispatch("GetPersonListFromServer", {});
			this.$store.dispatch("GetProjectListFromServer", {});
			this.$store.dispatch("GetLocalUserListForMention", {});
			this.$store.dispatch("GetPreInvoiceAbstractForPerson", {});
			this.$store.dispatch("GetContractAbstractForPerson", {});
			this.$store.dispatch("GetInvoiceAbstractForPerson", {});
			this.$store.dispatch("GetLetterAbstractForPerson", {});
			this.$store.dispatch("GetMeetingAbstractForPerson", {});
			this.$store.dispatch("GetBuyAbstractForPerson", {});
			this.$store.dispatch("GetWorkGroupListFromServer", {});
			setTimeout(function () {
				document.querySelectorAll('.vs__clear').forEach(input => {
					input.remove();
				});
			}, 500)
		},

		methods: {
			selectPreferenceType(d) {
				this.taskModel.preferenceTypeId = d;
			},
			PersonFilter(item, queryText, itemText) {
				if (queryText.length > 3)
					this.$store.dispatch("GetPersonListFromServer", {
						text: queryText,
					});
				return this.$store.getters.GetPersonList;
			},
			onchangePerson() {
				this.taskModel.projectId = null;
				this.taskModel.invoiceId = null;
				this.taskModel.preInvoiceId = null;
				this.taskModel.contractId = null;
				this.taskModel.letterId = null;
				this.taskModel.meetingId = null;
				this.taskModel.preBuyInvoiceId = null;
				this.taskModel.buyId = null;
				this.$store.dispatch("GetProjectListFromServer", {
					personId: this.taskModel.personId,
				});
				this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
					personId: this.taskModel.personId,
				});
				this.$store.dispatch("GetContractAbstractForPerson", {
					personId: this.taskModel.personId,
				});
				this.$store.dispatch("GetInvoiceAbstractForPerson", {
					personId: this.taskModel.personId,
				});
				this.$store.dispatch("GetLetterAbstractForPerson", {
					personId: this.taskModel.personId,
				});
				this.$store.dispatch("GetMeetingAbstractForPerson", {
					personId: this.taskModel.personId,
				});
				this.$store.dispatch("GetBuyAbstractForPerson", {
					personId: this.taskModel.personId,
				});
			},


			ProjectFilter(item, queryText, itemText) {
				if (queryText.length > 3)
					this.$store.dispatch("GetProjectListFromServer", {
						text: queryText,
						personId: this.taskModel.personId,
					});
				return this.$store.getters.GetProjectList;
			},
			onchangeProject() {
				this.taskModel.contractId = null;
				this.taskModel.meetingId = null;
				this.$store.dispatch("GetContractAbstractForPerson", {
					text: "",
					personId: this.taskModel.personId,
					projectId: this.taskModel.projectId,
				});
				this.$store.dispatch("GetMeetingAbstractForPerson", {
					personId: this.taskModel.personId,
					projectId: this.taskModel.projectId,
				});
			},


			PreInvoiceFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
						text: queryText,
						personId: this.taskModel.personId,
						projectId: this.taskModel.projectId,
					});
				return this.$store.getters.GetPreInvoiceList;
			},
			onchangePreInvoice() {
				//this.taskModel.contractId = null;
				this.taskModel.invoiceId = null;
				this.$store.dispatch("GetInvoiceAbstractForPerson", {
					text: "",
					preInvoiceId: this.taskModel.preInvoiceId,
					contractId: this.taskModel.contractId,
					personId: this.taskModel.personId,
				});
			},



			ContractFilter(item, queryText, itemText) {
				if (queryText.length > 3)
					this.$store.dispatch("GetContractAbstractForPerson", {
						text: queryText,
						personId: this.taskModel.personId,
					});
				return this.$store.getters.GetContractList;
			},
			onchangeContract() {
				this.taskModel.invoiceId = null;
				this.taskModel.buyId = null;
				this.taskModel.meetingId = null;
				this.$store.dispatch("GetInvoiceAbstractForPerson", {
					text: "",
					preInvoiceId: this.taskModel.preInvoiceId,
					contractId: this.taskModel.contractId,
					personId: this.taskModel.personId,
				});
				this.$store.dispatch("GetMeetingAbstractForPerson", {
					personId: this.taskModel.personId,
					projectId: this.taskModel.projectId,
					contractId: this.taskModel.contractId,
				});
				this.$store.dispatch("GetBuyAbstractForPerson", {
					personId: this.taskModel.personId,
					prebuyInvoiceId: this.taskModel.prebuyInvoiceId,
					contractId: this.taskModel.contractId,
				});

			},



			InvoiceFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetInvoiceAbstractForPerson", {
						text: queryText,
						preInvoiceId: this.taskModel.preInvoiceId,
						contractId: this.taskModel.contractId,
						personId: this.taskModel.personId,
					});
				return this.$store.getters.GetInvoiceList;
			},
			onchangeInvoice() {
				console.log("")
			},



			LetterFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetLetterAbstractForPerson", {
						text: queryText,
						personId: this.taskModel.personId,
					});
				return this.$store.getters.GetLetterList;
			},
			onchangeLetter() {
				console.log("")
			},



			MeetingFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetMeetingAbstractForPerson", {
						text: queryText,
						personId: this.taskModel.personId,
						contractId: this.taskModel.contractId,
						projectId: this.taskModel.projectId,
					});
				return this.$store.getters.GetMeetingList;
			},
			onchangeMeeting() {
				console.log("")
			},

			BuyFilter(item, queryText, itemText) {
				if (queryText.length > 0)
					this.$store.dispatch("GetBuyAbstractForPerson", {
						text: queryText,
						personId: this.taskModel.personId,
						prebuyInvoiceId: this.taskModel.prebuyInvoiceId,
						contractId: this.taskModel.contractId,
					});
				return this.$store.getters.GetBuyList;
			},
			onchangeBuy() {
				console.log("")
			},




			onChangeWorkGroup() {
				console.log("")

			},


			startR() {
				try {
					this.sr.start();
					this.showType = true;
					this.btnRecord = "btn btn-success speechToTextBtn-i-L";
				} catch (error) {
					console.error(error);
					this.showType = true;
					// Expected output: ReferenceError: nonExistentFunction is not defined
					// (Note: the exact output may be browser-dependent)
				}

			},
			stopR() {
				try {
					this.sr.stop();
					this.showType = false;
					this.btnRecord = "btn btn-danger speechToTextBtn-i";
				} catch (error) {
					console.error(error);
					this.showType = false;
					// Expected output: ReferenceError: nonExistentFunction is not defined
					// (Note: the exact output may be browser-dependent)
				}
			},
			ChangeWorkGroup() {
				this.getUserList()
			},
			CreateTask() {
				this.taskModel.suggestedPersonTime = this.taskModel.suggestPersonTimeHour + this.taskModel.suggestPersonTimeMinute;
				this.v$.$touch(); //it will validate all fields
				if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
					this.modified = false;
					if (this.taskModel.teamUserIdsList !== null) {
						this.taskModel.teamUserIds = this.taskModel.teamUserIdsList.join(",");
					}

					this.$store.dispatch("CreateTask", this.taskModel);
				}

			},
			getUserList() {
				this.taskModel.receiverUserId = null;
				this.taskModel.teamUserIdsList = null;
				this.taskModel.teamUserIds = null;
				this.$store.dispatch("GetLocalUserListListFromServer", {
					workGroupId: this.taskModel.workGroupId,
					expiredControl: true
				});
			},
			//getMeetingList() {
			//    this.$store.dispatch("GetMeetingListFromServer", { personId: this.taskModel.refPersonId });
			//},
			getTaskNo() {
				this.$http.get("Task/GetTasksNo")
					.then(data => {
						this.taskModel.taskNo = data.data;
						this.modified = false;
					});

			},
			CheckTaskTitle() {
				this.taskModel.suggestedPersonTime = this.taskModel.suggestPersonTimeHour + this.taskModel.suggestPersonTimeMinute;
				this.v$.$touch(); //it will validate all fields
				if (!this.v$.$invalid) {
					this.$http.get("Task/CheckTaskTitle?taskId=" + 0 + "&taskTypeId=" + this.taskModel.taskTypeId + "&title=" + this.taskModel.title)
						.then(data => {
							if (data.data.toString() === "1") {
								this.CreateTask();
							}
							else {
								VueSimpleAlert.fire({
									title: data.data,
									showCancelButton: true,
									confirmButtonText: 'تأیید و ثبت',
									cancelButtonText: `انصراف`,
								}).then((result) => {
									if (result.value == true) {
										this.CreateTask();
									} else {
										console.log("cancel save");
									}


								})
							}
						});
				}

			},
			getDefaultsForTask() {
				if (this.taskModel.taskTypeId == null || this.taskModel.taskTypeId == 0) {
					if (this.taskModel.teamUserIdsList != null) {
						var index = this.taskModel.teamUserIdsList.indexOf(this.taskModel.receiverUserId);
						if (index > -1) {
							this.taskModel.teamUserIdsList.splice(index, 1); // 2nd parameter means remove one item only
						}
					}
					this.$http.get("Task/getDefaultsForTask?receiverUserId=" + this.taskModel.receiverUserId)
						.then(data => {
							this.taskModel.priorityId = data.data.priorityId;
							this.taskModel.taskTypeId = data.data.taskTypeId;
							this.CalcTaskTimeByTaskTypeId();
						});
				}
			},
			GetCurrenctUserId() {
				this.$http.get("Task/getCurrentUserId")
					.then(data => {
						this.taskModel.currentUserId = data.data;
					});
			},
			CalcTaskTimeByTaskTypeId() {
				var _this = this;
				setTimeout(function () {
					if (_this.timingChanged) {
						VueSimpleAlert.fire({
							title: 'زمانبندی بر اساس  ' + this.lableText('TaskType') ?? 'نوع وظیفه' + ' دریافت شود؟',
							showCancelButton: true,
							confirmButtonText: 'بله',
							cancelButtonText: `خیر`,
						}).then((result) => {
							if (result.value == true) {
								_this.GetDataForCalcTaskTimeByTaskTypeId();
								_this.timingChanged = false;
							}
						})
					}
					else {
						_this.GetDataForCalcTaskTimeByTaskTypeId();
					}

				}, 100);

			},
			GetDataForCalcTaskTimeByTaskTypeId() {
				this.$http.get("Task/CalcTaskTimeByTaskTypeId?taskTypeId=" + this.taskModel.taskTypeId)
					.then(data => {
						if (data.data.endDatetimeFa != null) {
							this.taskModel.endDateTime = data.data.endDate + " " + data.data.endTime;
						}
						if (data.data.strSuggestWorkTime != null) {
							var h = data.data.strSuggestWorkTime.split(":");
							console.log(h);
							this.taskModel.suggestPersonTimeHour = h[0];
							this.taskModel.suggestPersonTimeMinute = h[1];
						}

					});
			},
			getServerDateTime() {
				this.$http.get("Task/GetServerDateTime")
					.then(data => {
						this.taskModel.startDateTime = data.data.replace('_', " ");
						this.taskModel.taskDate = data.data.split("_")[0];
						this.modified = false;
					});

			},
			SetTimingChanged(val) {
				this.timingChanged = val;
			},
			setDescription() {
				if (this.taskModel.description == null || this.taskModel.description == "") {
					this.taskModel.description = this.taskModel.title;
				}
			},
			setFolderItemList(list) {
				this.taskModel.taskFolderItemList = list;
			},
			onShowTypeModal(show) {
				if (show) {
					document.getElementsByClassName('menu-hider')[0].click();
				}
				this.showTypeModal = show;
			},
			fixTime() {

				var val = this.taskModel.suggestedPersonTime;
				if (val.length == 1) {
					val = '0' + val + ':00';
				}
				else if (val.length == 2) {
					val = val + ':00';
				}
				else if (val.length == 3) {
					val = val + '00';
				}
				else if (val.length == 4) {
					val = val + '0';
				}
				this.taskModel.suggestedPersonTime = val;
			},
			SetAttList(e) {
				this.taskModel.attList = e;
			},
			AttInProgress(e) {
				this.attInProgress = e;
			},
			onShowUserActivityClick() {
				this.showUserActivityModal = true;
				document.getElementsByClassName('menu-hider')[0].click();
			},
			pauseVid(id) {
				if (id != null) {
					var vid = document.getElementById(id);
					vid.pause();
				}
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
			toggleClasslessDetails() {
				var element = document.getElementById("moreLessDetails");
				element.classList.toggle("lessDetails");
			}
		},


		validations: {
			taskModel: {
				taskDate: {
					required
				},
				title: {
					required
				},
				priorityId: {
					required
				},
				taskTypeId: {
					required
				},
				receiverUserId: {
					required
				},
				suggestedPersonTime: {
					required
				},
				startDateTime: {
					required
				},
				endDateTime: {
					required
				},
				description: {
					required
				},
				suggestPersonTimeHour: {
					between: between(0, 1000)
				},
				suggestPersonTimeMinute: {
					between: between(0, 59)
				},
			}


		},
		directives: { maska },
		mounted() {
			try {

				this.sr = new Recognition()
				this.sr.continuous = true
				this.sr.interimResults = true
				this.sr.lang = 'fa-IR';
				var rest = "";
				this.sr.onstart = () => {
					this.showType = true;
					this.btnRecord = "btn btn-success speechToTextBtn-i-L";
				}
				this.sr.onresult = (evt) => {
					rest = evt.results[evt.results.length - 1][0].transcript;
				}
				this.sr.onend = () => {
					if (this.taskModel.description == null || this.taskModel.description == "null")
						this.taskModel.description = "";
					this.taskModel.description = this.taskModel.description + " " + rest
					this.btnRecord = "btn btn-danger speechToTextBtn-i";
					this.showType = false;
				}
			} catch (error) {
				console.error(error);
				// Expected output: ReferenceError: nonExistentFunction is not defined
				// (Note: the exact output may be browser-dependent)
			}
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
			this.modified = false;
		},
		beforeRouteLeave(to, from, next) {
			if (this.modified == true) {
				VueSimpleAlert.fire({
					title: 'با بستن این صفحه تغییرات شما ذخیره نخواهد شد. آیا ادامه می دهید؟',
					showCancelButton: true,
					confirmButtonText: 'تأیید',
					cancelButtonText: `انصراف`,
				}).then((result) => {

					if (result.value == true) {
						next();
					} else {
						next(false);
					}


				})
			}
			else {
				next();
			}
		}
	};
</script>
<style>
	.collapse-a:before {
		font-family: "Font Awesome 5 Free";
		content: "\f067";
		margin-left: 10px
	}

	.collapse-a .collapse-a-title:before {
		content: "جزئیات بیشتر";
	}

	.collapse-a.lessDetails:before {
		font-family: "Font Awesome 5 Free";
		content: "\f068";
		margin-left: 10px
	}

	.collapse-a.lessDetails .collapse-a-title:before {
		content: "جزئیات کمتر";
	}
</style>